module.exports = __webpack_public_path__ + "img/3.37b23d55.jpg";